export default __webpack_public_path__ + "static/l2-438062a75e4bf3cf9e79e0d14fe5258f.png";